import React from 'react';
import ReactLoading from 'react-loading';

type LoadingExpsProps = {
  currExp: number;
  totalExps: number;
};

function LoadingExps({ currExp, totalExps }: LoadingExpsProps) {
  return (
    <div id='loadingexps-wrapper'
      className="flex flex-xy-center flex-column"
      style={{ height: '100%', width: '100%' }}
    >
      <ReactLoading type="spinningBubbles" color="#F7A246" />
      <p id='loadingexps-creatingexp'>{`Creating ${currExp} of ${totalExps} Experiment...`}</p>
    </div>
  );
}

export default LoadingExps;
